/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsClassificationsCount
 */
export interface JumboStructsClassificationsCount {
    /**
     * 
     * @type {number}
     * @memberof JumboStructsClassificationsCount
     */
    malwareCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsClassificationsCount
     */
    otherCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsClassificationsCount
     */
    puaCount?: number;
    /**
     * 
     * @type {number}
     * @memberof JumboStructsClassificationsCount
     */
    ransomwareCount?: number;
}

/**
 * Check if a given object implements the JumboStructsClassificationsCount interface.
 */
export function instanceOfJumboStructsClassificationsCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsClassificationsCountFromJSON(json: any): JumboStructsClassificationsCount {
    return JumboStructsClassificationsCountFromJSONTyped(json, false);
}

export function JumboStructsClassificationsCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsClassificationsCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'malwareCount': !exists(json, 'malwareCount') ? undefined : json['malwareCount'],
        'otherCount': !exists(json, 'otherCount') ? undefined : json['otherCount'],
        'puaCount': !exists(json, 'puaCount') ? undefined : json['puaCount'],
        'ransomwareCount': !exists(json, 'ransomwareCount') ? undefined : json['ransomwareCount'],
    };
}

export function JumboStructsClassificationsCountToJSON(value?: JumboStructsClassificationsCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'malwareCount': value.malwareCount,
        'otherCount': value.otherCount,
        'puaCount': value.puaCount,
        'ransomwareCount': value.ransomwareCount,
    };
}

